import { useQuery } from "@tanstack/react-query";

import { api, call } from "@/core/api/client";
import { ENDPOINTS } from "@/core/api/endpoints";
import { QUERY_KEYS } from "@/core/api/query-client";
import type { components } from "@/core/api/schema";

export type ReportSummary = components["schemas"]["BrandReportSummary"];

/** The brand's numbers for the API's default period (the last 30 days, in the brand's time zone). */
export function useReportSummary(brandId: string, enabled: boolean) {
  return useQuery({
    queryKey: QUERY_KEYS.reportSummary(brandId),
    queryFn: async () =>
      (await call(api.GET(ENDPOINTS.reportSummary, { params: { path: { brandId } } }))).data,
    enabled,
  });
}
